import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
type Notification = {
  name: string;
  location: string;
  time: string;
  initials: string;
};
const notifications: Notification[] = [{
  name: 'Jessica Ramirez',
  location: 'Los Angeles, USA',
  time: '5 minutes ago',
  initials: 'JR'
}, {
  name: 'Carlos Mendoza',
  location: 'Miami, USA',
  time: '12 minutes ago',
  initials: 'CM'
}, {
  name: 'Sophie Walker',
  location: 'London, UK',
  time: '18 minutes ago',
  initials: 'SW'
}, {
  name: 'Andrea Lopez',
  location: 'Toronto, Canada',
  time: '27 minutes ago',
  initials: 'AL'
}, {
  name: 'Emily Clarke',
  location: 'Sydney, Australia',
  time: '41 minutes ago',
  initials: 'EC'
}];
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const showTimer = window.setTimeout(() => setVisible(true), 4500);
    return () => window.clearTimeout(showTimer);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const nextTimer = window.setTimeout(() => {
      setVisible(false);
      window.setTimeout(() => {
        if (!dismissed) {
          setIndex(current => (current + 1) % notifications.length);
          setVisible(true);
        }
      }, 700);
    }, 5000);
    return () => window.clearTimeout(nextTimer);
  }, [visible, dismissed]);
  if (dismissed) return null;
  const notification = notifications[index];
  return <div className="pointer-events-none fixed bottom-4 left-1/2 z-50 flex w-full -translate-x-1/2 justify-center px-4" data-id="element-291" data-mp="yjxtwhkv239s">
      <AnimatePresence mode="wait" data-id="element-292" data-mp="3nca3b39mdo3d">
        {visible && <motion.div key={notification.name} initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-xl border border-accent/40 bg-background p-3.5 shadow-elevated" data-id="element-293" data-mp="3j9n94vph7r30">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-accent/60 bg-primary-strong text-sm font-semibold text-primary-foreground" data-id="element-294" data-mp="31yqexkex59lg">
              {notification.initials}
            </span>
            <div className="min-w-0 flex-1" data-id="element-295" data-mp="2x1841ohcckat">
              <p className="text-xs text-muted-foreground" data-id="element-296" data-mp="2x1zy2uvai9yz">
                {notification.location}
              </p>
              <p className="mt-0.5 text-sm leading-5 text-foreground" data-id="element-297" data-mp="2j28or7fpxhrb">
                <strong className="font-semibold" data-id="element-298" data-mp="2n1zcf29y7hrm">{notification.name}</strong>{' '}
                purchased Barre Instructor Ready
              </p>
              <p className="mt-1 flex items-center gap-1 text-[11px] font-medium text-primary" data-id="element-299" data-mp="24gl2ngpyg35t">
                <ShoppingBagIcon size={11} aria-hidden="true" data-id="element-300" data-mp="1zi019dyyvdfs" /> Verified purchase ·{' '}
                {notification.time}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close purchase notification" className="self-start rounded text-muted-foreground transition-colors duration-150 hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" data-id="element-301" data-mp="28fk5mvs4lpum">
              <XIcon size={15} data-id="element-302" data-mp="2s4b4kwdyjsga" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}